import {NgModule} from '@angular/core';

import {SharedModule} from '../../shared/shared.module';

import {CadastrarSenhaComponent} from './cadastrar-senha/cadastrar-senha.component';
import {ConfirmacaoComponent} from './confirmacao/confirmacao.component';
import {ConfirmacaoCompraComponent} from './confirmacao-compra/confirmacao-compra.component';
import {DadosPessoaisComponent} from './dados-pessoais/dados-pessoais.component';
import {EsqueciSenhaComponent} from './esqueci-senha/esqueci-senha.component';
import {EtapaEmailComponent} from './etapa-email/etapa-email.component';
import {LoginComponent} from './login/login.component';
import {PagamentosComponent} from './pagamentos/pagamentos.component';
import {PagamentoBoletoComponent} from './pagamento-boleto/pagamento-boleto.component';
import {PagamentoCreditoComponent} from './pagamento-credito/pagamento-credito.component';
import {PagamentoDebitoComponent} from './pagamento-debito/pagamento-debito.component';
import {PropostaAnaliseComponent} from './proposta-analise/proposta-analise.component';
import {SegurancaComponent} from './seguranca/seguranca.component';
import {ResumoComponent} from './resumo/resumo.component';
import {ClientSalesComponent} from './client-sales/client-sales.component';
import { ConfirmacaoSalesComponent } from './confirmacao-sales/confirmacao-sales.component';
import { CheckinComponent } from './checkin/checkin.component';

@NgModule({
    imports: [ SharedModule ],
    providers: [],
    declarations: [
        PropostaAnaliseComponent,
        EtapaEmailComponent,
        ConfirmacaoCompraComponent,
        DadosPessoaisComponent,
        PagamentosComponent,
        PagamentoCreditoComponent,
        PagamentoDebitoComponent,
        PagamentoBoletoComponent,
        SegurancaComponent,
        ConfirmacaoComponent,
        CadastrarSenhaComponent,
        LoginComponent,
        EsqueciSenhaComponent,
        ResumoComponent,
        ClientSalesComponent,
        ConfirmacaoSalesComponent,
        CheckinComponent,
    ],
    exports: [
        PropostaAnaliseComponent,
        EtapaEmailComponent,
        ConfirmacaoCompraComponent,
        DadosPessoaisComponent,
        PagamentosComponent,
        PagamentoCreditoComponent,
        PagamentoDebitoComponent,
        PagamentoBoletoComponent,
        SegurancaComponent,
        ConfirmacaoComponent,
        CadastrarSenhaComponent,
        LoginComponent,
        EsqueciSenhaComponent,
        ResumoComponent,
        ClientSalesComponent,
        CheckinComponent,
    ]
})

export class PropostaModule { }
